var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center"},[_c('div',{staticClass:"spinner-border animate-spin inline-block border-white border-opacity-20 rounded-full bg-transparent",class:{
      'border-4 w-5 h-5': (_vm.size === 'sm'),
      'border-4 w-10 h-10': (_vm.size === 'md'),
      'border-8 w-20 h-20': (_vm.size === 'lg'),
    },style:({ 'border-top-color': _vm.color }),attrs:{"role":"status"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }